// src/components/global/Profile.tsx
import React from "react";
import {
  ProfileContainer,
  ImageWrapper,
  ProfileInfo,
  ProfileName,
  ProfileRole,
  ProfileDescription,
} from "./styled/Profile.styled";

interface ProfileProps {
  name: string;
  role: string;
  description?: string;
  imageSrc: string;
  socialLinks?: {
    linkedin?: string;
    github?: string;
    email?: string;
    whatsapp?: string;
  };
  cvUrl?: string;
}

export function Profile({ name, role, description, imageSrc }: ProfileProps) {
  return (
    <ProfileContainer>
      <ImageWrapper>
        <img src={imageSrc} alt={name} />
      </ImageWrapper>

      <ProfileInfo>
        {" "}
        <ProfileName>{name}</ProfileName>
        <ProfileRole>{role}</ProfileRole>
        {description && <ProfileDescription>{description}</ProfileDescription>}
      </ProfileInfo>
    </ProfileContainer>
  );
}

export default Profile;
